export default __webpack_public_path__ + "static/media/Agents_Icon.09a23452.png";